export const SCROLL_TROTTLING_DELAY = 100;
export const VERTICAL_VISIBLE_INDENT = 40;
export const SCROLL_CLICK_DEAD_ZONE = 2;
